import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { exists } from '../../../helpers';
import RawHtml from '../RawHtml';
import Styles from './Questions.styles';
import PlusIcon from './PlusIcon';

const QuestionWrapper = styled.div`${Styles.questionWrapper}`; // prettier-ignore
const Question = styled(RawHtml).attrs({ className: 'cbx-bold' })`${Styles.question}`; // prettier-ignore
const AnswerWrapper = styled.div`${Styles.answerWrapper}`; // prettier-ignore
const Answer = styled(RawHtml)`${Styles.answer}`; // prettier-ignore

/**
 * Questions Component
 */
class Questions extends PureComponent {
  /**
   * @property question - question prop
   * @property answer - answer prop
   */
  static propTypes = {
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    open: PropTypes.bool
  };

  /**
   * constructor method
   * @param {*} props - component props
   */
  constructor(props) {
    super(props);
    this.toggleAction = this.toggleAction.bind(this);
    this.state = {
      isQuestionOpen: props.open
    };
  }

  /**
   * toggle question state
   */
  toggleAction() {
    this.setState(({ isQuestionOpen }) => ({
      isQuestionOpen: !isQuestionOpen
    }));
  }

  /**
   * Render method
   * @returns {?JSX}
   */
  render() {
    const {
      state: { isQuestionOpen },
      props: { question, answer }
    } = this;

    if (!exists(question) || !exists(answer)) return null;

    return (
      <Fragment>
        <QuestionWrapper onClick={this.toggleAction}>
          <Question content={question} />
          <PlusIcon isActive={isQuestionOpen} />
        </QuestionWrapper>
        <AnswerWrapper isActive={isQuestionOpen}>
          <Answer isActive={isQuestionOpen} content={answer} />
        </AnswerWrapper>
      </Fragment>
    );
  }
}

export default Questions;
